import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=76391d13&scoped=true"
import script from "./Notification.vue?vue&type=script&lang=js"
export * from "./Notification.vue?vue&type=script&lang=js"
import style0 from "./Notification.vue?vue&type=style&index=0&id=76391d13&prod&scoped=true&lang=css"
import style1 from "./Notification.vue?vue&type=style&index=1&id=76391d13&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76391d13",
  null
  
)

export default component.exports